import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, throwIfError } from "../client";
import { fleetReportKeys } from "../query-keys";
import type { EventId } from "@/types/identifiers";

export { fleetReportKeys } from "../query-keys";

export function useFleetReport() {
  return useQuery({
    queryKey: fleetReportKeys.all,
    queryFn: async () => {
      const result = await api.GET("/api/fleet-report");
      return throwIfError(result, "Failed to fetch fleet weight report");
    },
  });
}

/** Publish or withdraw an event's weights for teams. Retractable by design. */
export function useSetWeightsRelease(eventId: EventId | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (released: boolean) => {
      if (!eventId) throw new Error("No current event to publish weights for");
      const path = { params: { path: { event_id: eventId } } };
      const result = released
        ? await api.POST("/api/events/{event_id}/weights-release", path)
        : await api.DELETE("/api/events/{event_id}/weights-release", path);
      return throwIfError(
        result,
        released ? "Failed to publish the weights" : "Failed to withdraw the weights",
      );
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: fleetReportKeys.all }),
  });
}
